import { render } from "./ConfirmDetailsBlock.vue?vue&type=template&id=10f74a67&scoped=true"
import script from "./ConfirmDetailsBlock.vue?vue&type=script&lang=js"
export * from "./ConfirmDetailsBlock.vue?vue&type=script&lang=js"

import "./ConfirmDetailsBlock.vue?vue&type=style&index=0&id=10f74a67&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f74a67"]])

export default __exports__